var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("\n     display:inline;\n     width:100%;\n     height:" + (_vm.d.height) + "px;\n     background-color: " + (_vm.active?'beige':'transparent') + ";"))})}
var staticRenderFns = []

export { render, staticRenderFns }